import React from 'react';
import ViewItems from '../../../components/ViewItems';
import Text from '../../../components/Text';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import CustomCheckbox from '../../../components/CustomCheckbox';
import ViewReverse from '../../../components/ViewReverse';
import { ReactSVG } from 'react-svg';
import icons from '../../../constants/icons';

const SingleDocumentView = ({ label, isAgree, onPressAgree, getContentKey, onView, onClick }) => {
  const { TextWeight } = dynamicfunction();
  return (
    <ViewItems className='rounded-2xl sm:rounded-2xl border border-grey p-2.5 sm:p-3 w-full'>
      <Text
        text={label}
        size={fontSizes.h14}
        weight={TextWeight.semiBold}
        color='text-black'
        isTruncate={false}
      />

      {isAgree ? (
        <ViewReverse className='gap-3 mt-4'>
          <ViewReverse
            className='justify-center cursor-pointer items-center gap-3 border border-primary rounded-lg py-2 px-5'
            onClick={onView}
          >
            <ReactSVG src={icons?.view_icon} />
            <Text
              text={getContentKey('view')}
              color='text-primary'
              isTruncate={false}
            />
          </ViewReverse>
          {/* <a href={document} download target="_blank"> */}
          <ViewReverse
            className='justify-center cursor-pointer items-center gap-3 border border-primary rounded-lg py-2 px-5'
            onClick={() => onClick()}>
            <ReactSVG src={icons?.download_icon} />
            <Text
              text={getContentKey('download')}
              color='text-primary'
              isTruncate={false}
            />
          </ViewReverse>
          {/* </a> */}
        </ViewReverse>
      ) : (
        <Text
          text={
            <>
              {getContentKey('please_agree')}{' '}
              <Text
                text={getContentKey('non_disclosure_agreement')}
                color='text-primary text-silver'
                className={'inline'}
              />{' '}
              {getContentKey('view')} {label}
            </>
          }
          size={fontSizes.h12}
          weight={TextWeight.regular}
          color='text-silver'
          isTruncate={false}
          className={'mt-4'}
        />
      )}
      {!isAgree && (
        <CustomCheckbox
          isChecked={isAgree}
          onClick={onPressAgree}
          label={getContentKey('i_agree')}
          className={'mt-4'}
        />
      )}
    </ViewItems>
  );
};

export default SingleDocumentView;
